import type {
  CustomerDataEvent,
  SendGtmEvent
} from '@/modules/shared/utils/gtmEvents/customerDataTypes';
import CustomerDataEvents from '@/modules/shared/utils/gtmEvents/events/customerDataEvents';
import { sendGtmEvent } from '@/modules/shared/utils/gtmEvents/Manager';

export function sendEvent({ event, extraFields }: SendGtmEvent): void {
  const eventObj: CustomerDataEvent = {
    ...CustomerDataEvents[event],
    ...(extraFields || {})
  };

  sendGtmEvent(eventObj);
}
